'use strict';

import * as debounce from 'lodash/debounce';

export default class VZPlpQuantitySelector extends HTMLElement {
    constructor() {
        super();

        this.excludedAttributes = ['class', 'data-configurator-type', 'data-url', 'data-general-error'];

        this.onInput = this.onInput.bind(this);

        this.toggleIncreaseAndDecreaseButtons = this.toggleIncreaseAndDecreaseButtons.bind(this);
    }

    connectedCallback() {
        this.forbiddenValues = ['e', '+', ',', '-', '.', 69, 187, 188, 189, 190];
        this.activeClass = 'has-value';

        this.debounceRate = parseFloat(this.getAttribute('debounce-rate')) || 500;
        this.debouncedChange = debounce(this.onChange.bind(this), this.debounceRate);

        this.parentId = this.getAttribute('data-parent-id');
        this.parent = document.querySelector(`#${this.parentId}`);
        this.aside = this.parent.querySelector('.js-aside');

        this.minQuantity = parseInt(this.getAttribute('data-min-qty'), 10);

        this.quantityField = this.querySelector('.js-quantity-field');
        this.quantityFieldOriginalValue = this.quantityField.value;

        this.quantityField.addEventListener('blur', this.onBlur.bind(this));

        this.addEventListener('input', this.onInput.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        this.addEventListener('paste', this.onPaste);
        this.addEventListener('plp:setQty', this.onChange.bind(this));

        [...this.querySelectorAll('.js-quantity-decrease, .js-quantity-increase')].forEach((element) => {
            element.addEventListener('click', this.decreaseOrIncrease.bind(this));
        });
        this.dispatchEvent(new CustomEvent('plp:qtySelectorReady'));
    }

    toggleIncreaseAndDecreaseButtons(disableOrEnable) {
        const buttons = [...this.querySelectorAll('.js-quantity-decrease, .js-quantity-increase')];
        buttons.forEach((button) => (disableOrEnable === 'disable' ? button.setAttribute('disabled', true) : button.removeAttribute('disabled')));
    }

    onBlur(e) {
        if (e.target.value.length !== 0) return;

        e.target.value = '0';

        this.validateMinMax();
        this.debouncedChange();
    }

    onInput(e) {
        if (e.target.value.length === 0) return;

        this.validateMinMax();
        this.debouncedChange();
    }

    onKeyDown(e) {
        if (this.forbiddenValues.indexOf(e.key || e.keyCode) !== -1) {
            e.preventDefault();
        }
    }

    onPaste(e) {
        e.preventDefault();

        const newValue = e.clipboardData.getData('text').replace(/\D/g, '');

        e.target.value = '';
        e.target.value = newValue;

        this.validateMinMax();
        this.debouncedChange();
    }

    decreaseOrIncrease(e) {
        e.preventDefault();

        const field = this.quantityField;
        const currentValue = parseInt(field.value, 10);
        const decrease = e.target.classList.contains('js-quantity-decrease');

        if (window.isNaN(currentValue)) {
            field.value = field.min;
        } else if (decrease) {
            field.value = currentValue === this.minQuantity ? 0 : currentValue - 1;
        } else {
            field.value = currentValue === 0 || currentValue < this.minQuantity ? this.minQuantity : currentValue + 1;
        }

        this.validateMinMax();
        this.debouncedChange();
    }

    validateMinMax() {
        const field = this.quantityField;
        const moreThanMax = parseInt(field.value, 10) > field.max;
        const lessThanMin = parseInt(field.value, 10) < field.min;

        if (field.max && moreThanMax) field.value = field.max;
        if (lessThanMin) field.value = field.min;
    }

    onChange() {
        const field = this.quantityField;

        // Keep minimum allowed quantity in mind
        if (field.value > 0 && field.value < this.minQuantity) field.value = this.minQuantity;

        this.toggleClasses(field.value);
        this.dispatchEvent(new CustomEvent('plp:tileUpdated'));

        if (field.value === this.quantityFieldOriginalValue) return;

        field.setAttribute('value', field.value);
        field.dispatchEvent(new CustomEvent('fieldUpdated'));
    }

    toggleClasses(value) {
        if (value > 0) {
            this.aside.classList.add(this.activeClass);
        } else {
            this.aside.classList.remove(this.activeClass);
        }
    }
}

if (!window.customElements.get('vz-plp-quantity-selector')) {
    window.customElements.define('vz-plp-quantity-selector', VZPlpQuantitySelector);
}
